module.exports = __webpack_public_path__ + "static/media/Bulk_Trucks_Availability_sample.cb1a9219.csv";